import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import { Client, ClientRequest, ClientResponse } from './types'

export const clientsListMounted = createEvent<ClientRequest>()

export const getClients = fx<ClientRequest, ClientResponse>({
  method: 'GET',
  url: `/client`,
})

export const $clients = restore<Client[]>(
  getClients.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfClients = restore(
  getClients.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: clientsListMounted,
  fn: ({ limit, page, orderBy, orderDirection, filters }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    let query: Record<string, any> = {
      limit,
      page,
    }

    if (orderBy) {
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      const where: Record<string, any> = {}

      // Text search fields
      if (filters.id) where['id'] = filters.id
      if (filters.email) where['email'] = filters.email.toLowerCase()
      if (filters.tsname) where['tsname'] = filters.tsname.toLowerCase()
      if (filters.documentNumber)
        where['verifications.documentNumber'] =
          filters.documentNumber.toLowerCase()
      if (filters.mtLogin) where['accounts.mtLogin'] = filters.mtLogin

      // Boolean filters
      if (filters.partner !== undefined) where['partner'] = `${filters.partner}`
      if (filters.verified !== undefined)
        where['verified'] = `${filters.verified}`
      if (filters.hasDeposit !== undefined)
        where['hasDeposit'] = `${filters.hasDeposit}`

      // Array filters
      if (filters.country && filters.country.length > 0)
        where['country'] = filters.country
      if (filters.products && filters.products.length > 0)
        where['products'] = filters.products

      // Date range
      if (filters.dateFrom) where['dateFrom'] = filters.dateFrom
      if (filters.dateTo) where['dateTo'] = filters.dateTo

      if (Object.keys(where).length > 0) {
        query['where'] = JSON.stringify(where)
      }
    }

    return { query }
  },
  target: getClients,
})
